import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from "lucide-react";

const Resources = () => {
  const navigate = useNavigate();
  const handleFreeConsultation = () => navigate('/contact');
  const blogs = [
    {
      category: "Labour Law Fundamentals",
      title: "What Every Employer Needs to Know About the Factories Act",
      snippet:
        "A guide to the Factories Act, 1948 — registration, safety obligations, welfare provisions, and the top compliance pitfalls for industrial employers across India.",
    },
    {
      category: "Payroll Compliance",
      title: "PF Compliance Calendar for Indian Employers — 2025 Edition",
      snippet:
        "Month-by-month breakdown of every PF filing deadline, ECR submission, and annual return requirement with state-specific variations.",
    },
    {
      category: "Inspection Readiness",
      title: "How to Prepare for a Factory Act Inspection",
      snippet:
        "What labour inspectors look for, how to conduct mock inspections, and how to respond to show-cause notices effectively.",
    },
    {
      category: "Technology in Compliance",
      title: "Why Manual Registers Are a Liability in 2025",
      snippet:
        "How digital compliance platforms reduce penalty risk, improve audit readiness, and cut team workload by up to 60%.",
    },
    {
      category: "Contract Labour",
      title: "Top 10 CLRA Compliance Mistakes — And How to Avoid Them",
      snippet:
        "The most common errors under CLRA and practical steps to build a bulletproof contract labour compliance framework.",
    },
    {
      category: "Industry Compliance",
      title: "Retail & Warehousing Compliance — Shops Act Across States",
      snippet:
        "State-by-state guide covering registrations, renewals, and requirements for retail chains and warehouse operators.",
    },
  ];

  return (
    <>
    <section className="bg-white py-20 px-6" id="resources">
      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div>
            <p className="text-[#d97925] text-sm font-semibold uppercase">
              Resources & Insights
            </p>
            <h2 className="text-4xl md:text-5xl font-bold mt-2 leading-tight">
              Compliance Knowledge <br /> Centre
            </h2>
          </div>

          <div className="text-gray-600 text-lg">
            Expert guidance on India's most complex statutory compliance topics
            — from Labour Law basics to inspection readiness.
          </div>
        </div>

        {/* BLOG GRID */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -8, scale: 1.02 }}
              className="border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition"
            >
              {/* CATEGORY */}
              <div className="text-xs text-[#d97925] font-semibold mb-2 uppercase">
                {blog.category}
              </div>

              {/* TITLE */}
              <h3 className="text-xl font-bold mb-3 leading-snug">
                {blog.title}
              </h3>

              {/* SNIPPET */}
              <p className="text-gray-600 text-sm leading-relaxed">
                {blog.snippet}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>

     <section className="py-28 bg-gradient-to-br from-[#111111] to-[#111111] text-white">
            <div className="max-w-7xl mx-auto px-6 text-center">
              <motion.h2
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9 }}
                className="text-5xl font-bold tracking-tight mb-8"
              >
                Practical Tools. Clear Guidance. Better Compliance.
              </motion.h2>
    
              <p className="text-2xl mb-12 max-w-3xl mx-auto opacity-90">
               Give your business the clarity in compliance, it needs to stay ahead.
              </p>
    
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleFreeConsultation}
                className="inline-flex items-center gap-4 px-12 py-7 bg-white text-[#d97925] font-bold text-2xl rounded-3xl shadow-2xl hover:bg-emerald-50 transition-colors"
              >
                Request a Free Consultation
                <ArrowRight size={32} />
              </motion.button>
            </div>
          </section>

    </>
  );
};

export default Resources;